export const DATE_FORMAT = 'DD.MM.YYYY';
export const TIME_FORMAT_SHORT = 'HH:mm';
export const DATE_TIME_FORMAT_SHORT = 'DD.MM.YYYY HH:mm';
